import React,{Component} from 'react'

/**
 * 消息弹窗V2
 * 
 * @export
 * @class TipPop
 * @extends {Component}
 * isOpen - 控制弹窗是否开启
 * msg—— 弹窗主体内容，支持html元素
 * jump—— 如果存在，并为函数，则点击执行自定义函数
 * 		  如果存在，并且为字符串，则点击跳转到自定义链接
 * 		  其他情况，默认确认按钮为关闭弹窗
 * onClose——如果为函数，则为关闭弹窗的回调函数
 * 			如果为false，则不设置确认按钮和关闭按钮
 * btnTxt——按钮文字 
 */
export default class PopUp extends Component {
	constructor(props){
		super(props)
        this.btnRender = this.btnRender.bind(this)
	}
	btnRender(){
		const {jump,onClose,btnTxt} = this.props;
		let jumpType = jump && typeof jump ;
		let noBtnRender = ()=>{
			return <div className="oc-pop-btnbox"></div>
		}
		let btnRenderInner = ()=>{
			let submitBtn = ()=>{
				if(jumpType=='function'){ 
					return <a href="javascript:;" className="btn-oc" onClick={()=>{jump();onClose()}}>{btnTxt}</a>
				}else if(jumpType=='string'){
					return <a href={jump} className="btn-oc">{btnTxt}</a>
				}else {
					return <a href="javascript:;" className="btn-oc" onClick={onClose}>{btnTxt}</a>
				}
			}
			return <div>
				<div className="oc-pop-btnbox">
					{submitBtn()}
				</div>
				<a href="javascript:;" className="oc-pop-close" onClick={onClose}>关闭</a>
			</div>
		}
		return onClose ? btnRenderInner() : noBtnRender()
	}
	render() {
		const {isOpen, msg} = this.props;
		let dangerousInnerHTML = {
			__html: msg
		}
		return isOpen ?
			<div className="oc-pop">
				<div className="oc-pop-wp">
					<div className="oc-pop-textbox oc-tb">
						<div className="oc-pop-text oc-tb-cell"
							dangerouslySetInnerHTML={dangerousInnerHTML}>
							
						</div>
					</div>
					{this.btnRender()}
				</div>
			</div>
		: null
	}
}
PopUp.defaultProps = {
	isOpen: false,
    msg: 'hello breeze',
    jump: '',
    onClose: ()=>console.log("this is a default func (●'◡'●)ﾉ♥"),
    btnTxt: '确定'
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/popupbox.jsx